// Shared site constants for Legacy Life & Retirement

export const CALENDLY_URL = "https://calendly.com/shawnksfg/new-meeting";
export const BOOK_URL = "https://fromregulartorich.com";
export const APPLE_PODCAST_URL =
  "https://podcasts.apple.com/us/podcast/the-cashflow-chronicles/id1768314180";
export const SPOTIFY_URL =
  "https://open.spotify.com/show/1gtZe3qKBYMRgkyTkJ4D9o?si=6K1dd6XqQPuyX2T7MIRnSg&nd=1&dlsi=13a0777988ef4591";
export const YOUTUBE_ID = "W7W7HCJGfUk";
export const YOUTUBE_URL = "https://www.youtube.com/@LegacyLifeandRetirement";
export const INSTAGRAM_URL = "https://www.instagram.com/legacylifeandretirement/";
export const LINKEDIN_URL = "https://www.linkedin.com/in/shawnkingsfg/";

// Book reader-review video (supplied)
export const BOOK_REVIEW_VIDEO_ID = "sgIMCV4jN3Y";

// Gated Save & Spend overview (delivered after signup later — do not embed publicly)
export const SAVE_SPEND_VIDEO_ID = "IZ6MiMNZ5aM";

export const LOW_STRESS_URL =
  "https://lowstresstrading.com/options?ref=LEGACYLIFE&url=lowstressoptions.com";
export const LOW_STRESS_PLAYLIST =
  "https://www.youtube.com/playlist?list=PLPFOpSOEjJzQ9JJogyN2T2OXAF1oJvhXK";

export const VIDEO_GROUPS = [
  {
    group: "Infinite Banking Fundamentals",
    videos: [
      { title: "Short Infinite Banking Explainer", id: "sVLJdJgDnTA" },
      { title: "How Much Premium Should You Pay?", id: "NpBrfndYNKU" },
      { title: "Overfunding or Maximizing the Policy", id: "MOrFy2QqBHE" },
    ],
  },
  {
    group: "Real-Life Applications",
    videos: [
      { title: "How to Pay Off Debt With Infinite Banking", id: "UCXJC9vLlOI" },
      { title: "Banking for Children", id: "M_qoZp92BCc" },
      { title: "How the Wealthy Utilize Whole Life for Legacy Building", id: "xJhccj0cHgA" },
    ],
  },
  {
    group: "Important Considerations",
    videos: [
      { title: "The Honest Truth About Term Versus Whole Life Cost", id: "y_VdAZ3FgsU" },
      { title: "Avoid These Mistakes and You’ll Be a Successful Banker", id: "mthNIN4myd0" },
    ],
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "/", type: "route" },
  {
    label: "Infinite Banking", href: "/infinite-banking", type: "route",
    children: [
      { label: "What Is Infinite Banking?", href: "/infinite-banking#plain-language" },
      { label: "How the System Works", href: "/infinite-banking#how-it-works" },
      { label: "Policy Design and Premium", href: "/infinite-banking#premium" },
      { label: "Policy Loans and Repayment", href: "/infinite-banking#capital-cycle" },
      { label: "Financing Choices", href: "/infinite-banking#financing-choices" },
      { label: "Common Mistakes", href: "/infinite-banking#common-mistakes" },
      { label: "Real Life Uses", href: "/infinite-banking#real-life-uses" },
    ],
  },
  {
    label: "Financial Solutions", href: "/financial-solutions", type: "route",
    children: [
      { label: "Cash Flow and Debt Payoff", href: "/financial-solutions#cash-flow" },
      { label: "Long-Term Care Planning", href: "/financial-solutions#long-term-care" },
      { label: "Annuities", href: "/financial-solutions#annuities" },
      { label: "Retirement Income Planning", href: "/financial-solutions#retirement" },
      { label: "Coaching and Mentorship", href: "/financial-solutions#coaching" },
      { label: "Low-Stress Options", href: "/financial-solutions#low-stress" },
    ],
  },
  { label: "Family & Legacy", href: "/family-legacy", type: "route" },
  { label: "Resources", href: "/resources", type: "route" },
  { label: "FAQs", href: "/faqs", type: "route" },
  { label: "About", href: "/about", type: "route" },
];

export const BRAND_NAME = "Legacy Life & Retirement";
// Centralized production site URL. Canonical, og:url, and structured-data URLs
// are all derived from this so they always point at the live domain.
export const DEFAULT_SITE_URL = "https://legacylifeandretirement.com";

export const getSiteUrl = () => {
  const configuredUrl = process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL;
  return configuredUrl.replace(/\/$/, "");
};

export const getCanonicalUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getSiteUrl()}${normalizedPath}`;
};
